<template>
  <div>
    <list-reports />
  </div>
</template>
<script>
import ListReports from './components/ListReports.vue'
export default {
  components: {
    ListReports,
  },
}
</script>
